// iframe の中で third-party cookie を使う権利 (storage access) を取り直すための薄い wrapper。
//
// 背景: WebKit は CHIPS (Partitioned cookie) を実装していないため、AnyCOMPASS の iframe に
// 埋め込まれた Kakeru ではセッション cookie が送り返されない。Storage Access API が
// third-party cookie を使う唯一の標準手段になる (log/188 work-log/1 §6)。
//
// 失われているのは cookie 本体ではなく「iframe の中でそれを使う権利」だけなので、権利さえ
// 戻れば生きているセッション (SESSION_COOKIE_AGE = 90 日) がそのまま送られる。
// パスワードの再入力は要らない。

// requestStorageAccess() を持つか。Chromium にも存在するため、これ単体では
// 「Safari かどうか」の判定にはならない。呼び出し側で 401 の観測と AND すること。
export const canRequestStorageAccess = (): boolean =>
  typeof document !== 'undefined' && 'requestStorageAccess' in document

// 権利を要求する。true = 取得できた。
//
// 必ずユーザー操作のハンドラから呼ぶこと。transient user activation が切れていると
// WebKit は無条件に拒否する。呼び出し側で await を挟むと activation を使い切るため、
// ハンドラの先頭で呼ぶ。
//
// hasStorageAccess() を事前判定に使ってはならない。Chromium は CHIPS で cookie が
// 通っている状態でも「非分割 cookie へのアクセスは未許可」として false を返すため、
// 今 100% 動いている Edge に不要な導線とダイアログが出る (log/188 work-log/6 §4.1)。
export const requestStorageAccessOnce = async (): Promise<boolean> => {
  if (!canRequestStorageAccess()) return false
  try {
    await document.requestStorageAccess()
    return true
  } catch {
    return false
  }
}
